module.exports = __webpack_public_path__ + "DSC05520.1fa3f86f53c8298b1430.jpg";